import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

	constructor(private http: HttpClient) { }

 	forgotPassword(data): Observable<any> {
    	const url = `forgot-password`;
    	return this.http.post(url,data).pipe(
        retry(1),
		tap(
		event => ''
		)
      );
  }
  validateSecretQuestion(data): Observable<any> {
    	const url = `validate-secret-question`;
    	return this.http.post(url,data).pipe(
        retry(1),
		tap(
		event => ''
		)
      );
  }
  
  resetPassword(data): Observable<any> {
    	const url = `reset-password`;
    	return this.http.post(url,data).pipe(
        retry(1),
		tap(
		event => ''
		)
      );
  }    
}
